export class Tag {
    name: string;
    value: string;

    constructor(name: string) {
        this.name = name;
        this.value = this.sanitize();
    }

    public sanitize(): string {
        if (!this.name) {
            return '';
        }

        return this.name
            .normalize('NFD')
            .replaceAll(/[\u0300-\u036f]/g, '')
            .replaceAll(' ', '-')
            .toLowerCase();
    }
}
